module.exports = __webpack_public_path__ + "img/macOS-active.b71c72f.svg";